
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1px7g_zk0gu_9",
  "chart-filter": "awsui_chart-filter_1px7g_zk0gu_41",
  "custom-icon-wrapper": "awsui_custom-icon-wrapper_1px7g_zk0gu_45"
};
  